interface IQueueStatus {
  size?: 'sm' | 'md' | 'lg';
  status?: boolean;
  variant?: 'primary' | 'warning';
}

export const QueueStatus = ({ size = 'md', variant = 'primary' }: IQueueStatus) => {
  const color = variant === 'primary' ? 'bg-[#00771A]' : 'bg-[#FF862E]';

  const sizeClassNames = size === 'sm' ? 'h-2 w-2' : size === 'md' ? 'h-3 w-3' : 'h-5 w-5';

  return <span className={`rounded-full ${sizeClassNames} ${color}`} />;
};

QueueStatus.displayName = 'QueueStatus';
